var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPhaserIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 734.27 578.71",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;}.cls-2{clip-path:url(#clippath);}.cls-3{fill:#fff;}.cls-4{fill:#b8eefe;}.cls-5{fill:#8fb7e5;}.cls-6{mix-blend-mode:overlay;}.cls-7{fill:url(#radial-gradient-2);}.cls-8{mix-blend-mode:soft-light;}.cls-9{fill:url(#radial-gradient);}.cls-10{isolation:isolate;}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m524.48,180.32h-50.35l50.35,41.94v25.16h-96.5v-25.16h54.55l-54.55-37.74v-29.35h96.5v25.16Zm-264.34,67.1h-29.37v-92.26h29.37v33.55h29.37v-33.55h29.37v92.26h-29.37v-33.55h-29.37v33.55Zm113.29-62.9l-20.98,62.9h-29.37l33.57-92.26h33.57l33.57,92.26h-29.37l-20.98-62.9Zm-239.16-29.35v92.26h29.37v-62.9h37.76v4.19h-33.57l12.59,29.35h46.15v-62.9h-92.31Zm478.32,29.35v-29.35h-83.92v92.26h83.92v-25.16h-58.74v-4.19h58.74v-29.35h-58.74v-4.19h58.74Zm79.72,29.35h20.98v-58.71h-96.5v92.26h29.37v-62.9h37.76v4.19h-33.57l33.57,79.68h29.37l-20.98-54.52Z"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient",
    cx: 427.97,
    cy: 289.35,
    fx: 427.97,
    fy: 289.35,
    r: 289.43,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#bfebfd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#bfebfd",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-2",
    cx: 427.97,
    cy: 184.52,
    fx: 427.97,
    fy: 184.52,
    r: 134.23,
    xlinkHref: "#radial-gradient"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-10"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Tweaked"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m698.7,218.06h18.78v-67.1h-293.71c0,11.93.45,22.9.42,34.83,0,.79.28,1.22.9,1.67,25.34,18.15,44.63,30.59,44.63,30.59h-45.96s.49,9.35.49,15.36c-.06.01-.17,2.04-.17,2.04l-31.69-84.5h-37.96s-22.34,58.49-31.58,86.22c-.1,0-.19-4.02-.28-4.03v-71.31c0-7.11.49-10.88.49-10.88h-37.76v33.55h-20.98v-33.55h-134.27v100.64h37.76s.37-33.42.37-51.01c.09-.02.18-.03.26-.05,2.6,6.7,5.12,14.93,7.76,21.71h50.35v29.35h37.76v-33.55h20.98v33.55h70.33l18.09-55.39,17.47,55.39h259.14v-51.32l30.9,72.27,38.43.02-20.98-54.52Zm-174.22-33.55v32.35l-40.76-32.35h40.76Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m524.48,180.32h-50.35l50.35,41.94v25.16h-96.5v-25.16h54.55l-54.55-37.74v-29.35h96.5v25.16Zm-264.34,67.1h-29.37v-92.26h29.37v33.55h29.37v-33.55h29.37v92.26h-29.37v-33.55h-29.37v33.55Zm113.29-62.9l-20.98,62.9h-29.37l33.57-92.26h33.57l33.57,92.26h-29.37l-20.98-62.9Zm-239.16-29.35v92.26h29.37v-62.9h37.76v4.19h-33.57l12.59,29.35h46.15v-62.9h-92.31Zm478.32,29.35v-29.35h-83.92v92.26h83.92v-25.16h-58.74v-4.19h58.74v-29.35h-58.74v-4.19h58.74Zm79.72,29.35h20.98v-58.71h-96.5v92.26h29.37v-62.9h37.76v4.19h-33.57l33.57,79.68h29.37l-20.98-54.52Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "m427.97,0c159.89,0,289.51,129.55,289.51,289.35s-129.62,289.35-289.51,289.35S138.46,449.16,138.46,289.35,268.08,0,427.97,0Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-6"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "m427.97,50.32c74.15,0,134.27,60.08,134.27,134.19s-60.11,134.19-134.27,134.19-134.27-60.08-134.27-134.19,60.11-134.19,134.27-134.19Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-8"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m167.83,130h109.09l-167.83,146.77H0l167.83-146.77Zm180.42,0h29.37l-167.83,146.77h-29.37l167.83-146.77Zm75.52,0h71.33l-167.83,146.77h-71.33l167.83-146.77Zm100.7,0h54.55l-167.83,146.77h-54.55l167.83-146.77Zm79.72,0h29.37l-167.83,146.77h-29.37l167.83-146.77Zm100.7,0h29.37l-167.83,146.77h-29.37l167.83-146.77Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-8"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m167.83,130h109.09l-167.83,146.77H0l167.83-146.77Zm180.42,0h29.37l-167.83,146.77h-29.37l167.83-146.77Zm75.52,0h71.33l-167.83,146.77h-71.33l167.83-146.77Zm100.7,0h54.55l-167.83,146.77h-54.55l167.83-146.77Zm79.72,0h29.37l-167.83,146.77h-29.37l167.83-146.77Zm100.7,0h29.37l-167.83,146.77h-29.37l167.83-146.77Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m415.38,159.36l-281.12-4.19h579.02l-297.9,4.19Z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhaserIcon);
export default __webpack_public_path__ + "static/media/phaser-icon.5cc73105693a17c57456dbeeb7f43711.svg";
export { ForwardRef as ReactComponent };